(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["email-signup-modal"] && !Shopify.designMode) return;
  try {
    
    document.querySelector('#close-modal').addEventListener('click', e => {
    
        var elements = document.querySelectorAll('.to-hide');
        for (var elem of elements) {
          elem.classList.add('hide');
        }

    })  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  class InfiniteScrollGrid {
    constructor(sentinel) {
      this.sentinel = sentinel;
      this.sectionId = sentinel.dataset.sectionId;
      this.grid = document.querySelector('.infinite-scroll-grid[data-section-id="' + this.sectionId + '"]');
      this.loading = false;
      this.nextUrl = sentinel.dataset.nextUrl;
      this.observer = new IntersectionObserver(this.onIntersect.bind(this), { rootMargin: '600px' });
      this.observer.observe(this.sentinel);
    }

    onIntersect(entries) {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !this.loading && this.nextUrl) {
          this.loadMore();
        }
      });
    }

    async loadMore() {
      this.loading = true;
      try {
        const res = await fetch(this.nextUrl);
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newGrid = doc.querySelector('.infinite-scroll-grid[data-section-id="' + this.sectionId + '"]');
        const newSentinel = doc.querySelector('.infinite-scroll-sentinel[data-section-id="' + this.sectionId + '"]');

        if (newGrid) {
          Array.from(newGrid.children).forEach((child) => this.grid.appendChild(child));
        }

        if (newSentinel && newSentinel.dataset.nextUrl) {
          this.nextUrl = newSentinel.dataset.nextUrl;
        } else {
          this.nextUrl = null;
          this.observer.disconnect();
          this.sentinel.remove();
        }
      } catch (e) {
        console.error('Infinite scroll failed to load more products', e);
      } finally {
        this.loading = false;
      }
    }
  }

  document.querySelectorAll('.infinite-scroll-sentinel').forEach((el) => new InfiniteScrollGrid(el));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection_custom"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', function () {
  var ul = document.querySelector('ul.random');
  var count = 0;
  for (var i = ul.children.length; i >= 0; i--) {
    var element = ul.children[Math.random() * i | 0]
    ul.appendChild(element);
    if(count > 4)
      element.classList.add("hide");
    count ++;
  }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  // Player ———————————————————

  var player = document.getElementById("audio");
  var sound = false;
  var el = document.querySelector('.sound');

  el.onclick = function () {
    console.log("click")
      el.classList.toggle('sound-mute');
      sound = ! sound;
      if (sound) {
          player.play();
      } else {
          player.pause();
      }
  }
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header_backup"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-featured-v2"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', function () {

  document.body.classList.add('visible_page');
  document.body.classList.remove('hidden_page');

});


// Tooltips ———————————————————

const showEvents = [
    'click',
    'focus', 
    'mouseover'
];
const hideEvents = [
    'mouseleave',
    'blur',
];

const container = document.querySelector(".slide-container");

const hotspots = document.querySelectorAll('.hotspot-container');
let tooltips = [];

window.addEventListener("click", function(e) {
  if(e.target.className == "hotspots"){
    tooltips.forEach(tooltip => {
        tooltip.removeAttribute('data-show');
    });
  } else if(e.target.className == "hotspot--cta"){
      //const sel = e.querySelector('.tooltip');
      //console.log(e.target.querySelector('.tooltip'))
 
  }
});


hotspots.forEach(hotspot => {
   
    const button = hotspot.querySelector('.hotspot');
    const tooltip = hotspot.querySelector('.tooltip');
    const close = hotspot.querySelector('.tooltip-head-close');

    tooltips.push(tooltip);

    const popperInstance = Popper.createPopper(button, tooltip);

    showEvents.forEach((event) => {
        button.addEventListener(event, show);  
    });

    hideEvents.forEach((event) => {
        tooltip.addEventListener(event, hide);  
        button.addEventListener(event, hide);  
    });

    close.addEventListener("click", hideAll);  

    function show() {
        tooltips.forEach(tooltip => {
            tooltip.removeAttribute('data-show');
        });

        tooltip.setAttribute('data-show', '');
        popperInstance.update();
    }
    function hide(e) {  

        //console.log(e.toElement.classList.contains('box, arrow, hotspots, hotspot'));
        if(e.toElement === null || e.toElement.classList.contains('hotspots')){
            tooltip.removeAttribute('data-show');
        } 
    }
     function hideAll() { 
        console.log("hide all");
         tooltip.removeAttribute('data-show');
     } 
});

// background ———————————————————

window.addEventListener('resize', position);


document.addEventListener("DOMContentLoaded", function() {
 
  var imgs = document.images,
    len = imgs.length,
    counter = 0;

    [].forEach.call( imgs, function( img ) {
        if(img.complete)
        incrementCounter();
        else
        img.addEventListener( 'load', incrementCounter, false );
    } );

    function incrementCounter() {
        counter++;
        if ( counter === len ) {
            //console.log( 'All images loaded!' );
             position();
        }
    }
});

function position() {
     document.querySelectorAll('.slide-image').forEach(function (img) { 
        const aspectRatio = window.innerWidth/ window.innerHeight;
        const imageRatio = img.naturalWidth / img.naturalHeight;
        //console.log("Aspect ratio :"  + aspectRatio);
        //console.log("Image ratio :"  + imageRatio);
   
        if(aspectRatio > imageRatio) {
            img.classList.add("landscape-width");
            img.classList.remove("portrait-width");
        } else {
            img.classList.add("portrait-width");
            img.classList.remove("landscape-width");
        }

        var margin_left = (img.width - window.innerWidth) / 2
        img.parentElement.style.marginLeft = - margin_left + "px";
        var margin_top = (img.height - window.innerHeight) / 2
        img.parentElement.style.marginTop = - margin_top + "px";
    
    });

}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-featured"] && !Shopify.designMode) return;
  try {
    

var player = document.getElementById("audio"); 
var sound = false;
var el = document.querySelector('.sound');

el.onclick = function() {
  el.classList.toggle('sound-mute');
  sound = !sound;
  if(sound) {
    player.play();
  } else {
    player.pause();
  }
}




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
document.addEventListener('click', function (event) {

	if (!event.target.matches('.close-button')) return;

	event.preventDefault();

    var element = document.getElementById('ribbon-form');
    element.style.display = 'none';

}, false);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
               let mediaDivs = document.querySelectorAll(".grid__item");

                mediaDivs.forEach((mediaDiv) => {
                  let firstImg = mediaDiv.querySelector(".img1");
                  let secondImg = mediaDiv.querySelector(".img2");

                  if (firstImg && secondImg) {
                    firstImg.style.opacity = "1";
                    secondImg.style.opacity = "1";

                    mediaDiv.addEventListener("mouseover", function () {
                      firstImg.style.opacity = "0";
                    });

                    mediaDiv.addEventListener("mouseout", function () {
                      firstImg.style.opacity = "1";
                    });
                  }
                });
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
